import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal } from "antd";
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon, langPage } from "../../../locales";
import { MemberServer } from "../../../server";
import { generateAmountOperationFormConfig } from './config'

const server = MemberServer.User;
const lang = langPage?.member?.user;

export const SafeBalance = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [balance, setBalance] = useState<any>(0);

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any) => {
        if (val) {
            setLoading(true)
            run(val)
        }
        setVisiable(!!val);
    }

    const { run } = useRequest(server.safeBoxBalance, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            setBalance(res?.Balance)
            setLoading(false)
            onSuccess?.();
        }
    });

    return (
        <div>
            <Modal
                title="查看保险箱余额"
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
            >
                <div className="pd20">
                    <span className="pr10">保险箱余额：</span>
                    <span>{balance}</span>
                </div>
            </Modal>
        </div>
    );
})
